import { HStack, Button, Text } from "@chakra-ui/react";
import { useState, useRef } from "react";
import { handleYtdToggle } from "../../utils";

const YtdToggle = ({ labelLeft = "Monthly Performance", labelRight = "Year-To-Date Performance"}) => {
  const [isYtd, setIsYtd] = useState(() => {
    try {
      return sessionStorage.getItem("ytd") === "true";
    } catch {
      return false;
    }
  });

  const [isDisabled, setIsDisabled] = useState(false);
  const timeoutRef = useRef(null);

  const handleToggle = (next) => {
    if (isDisabled) return;
    setIsDisabled(true);

    setIsYtd(next);
    handleYtdToggle(next);

    try {
      sessionStorage.setItem("ytd", JSON.stringify(next));
    } catch {}

    clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(() => setIsDisabled(false), 500);
  };

  return (
    <HStack
      size="sm"
      width="100%"
      height={{ base: "auto", md: "56px" }}
      borderRadius="8px"
      overflow="hidden"
      bgColor="#E6E9EC"
      p="6px"
      spacing={1}
      flexDirection={{ base: "column", md: "row" }}
    >
      <Button
        onClick={() => handleToggle(false)}
        bg={!isYtd ? "white" : "#E6E9EC"}
        color="#262A2C"
        _hover={{ bg: !isYtd ? "white" : "#E6E9EC" }}
        flex="1"
        height="40px"
        borderRadius="8px"
        fontSize={ "18px" }
        width={{ base: "100%", md: "auto" }}
        minH="36px"
        isDisabled={isDisabled}
        fontWeight={700}
      >
        <Text>{labelLeft}</Text>
      </Button>

      <Button
        onClick={() => handleToggle(true)}
        bg={isYtd ? "white" : "#E6E9EC"}
        color="#262A2C"
        _hover={{ bg: isYtd ? "white" : "#E6E9EC" }}
        flex="1"
        height="40px"
        borderRadius="8px"
        fontSize={ "18px" }
        width={{ base: "100%", md: "auto" }}
        minH="36px"
        fontWeight={700}
        isDisabled={isDisabled}
      >
        <Text>{labelRight}</Text>
      </Button>
    </HStack>
  );
};

export default YtdToggle;